import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { styles } from './ProgressBar.css';
import React, { ReactNode } from 'react';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';

interface ProgressBarProps {
  currentItemsCount: number;
  totalItemsCount: number;
  shouldShowText?: boolean;
  icon?: ReactNode;
  shouldShowCompleteIcon?: boolean;
  size?: 'small' | 'medium';
  className?: string;
}

export const ProgressBar = ({
  currentItemsCount,
  totalItemsCount,
  shouldShowText,
  icon,
  shouldShowCompleteIcon,
  size = 'small',
  className = '',
}: ProgressBarProps) => {
  const progressPercentage = (currentItemsCount / totalItemsCount) * 100;
  const isFull = currentItemsCount >= totalItemsCount;
  return (
    <>
      {shouldShowText ? (
        <div className={styles.progressBarText}>{`Showing ${currentItemsCount} of ${totalItemsCount}`}</div>
      ) : null}
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={totalItemsCount}
        aria-valuenow={currentItemsCount}
        className={classNames([className, styles.progressBar({ size })])}
      >
        <div
          role="presentation"
          className={styles.progressBarFilled({ size, isFull: isFull })}
          style={{ width: `${progressPercentage}%` }}
        >
          {icon ? (
            <>
              <span
                className={classNames([
                  className,
                  styles.icon({
                    size,
                    isEmpty: currentItemsCount === 0,
                    isFull: isFull,
                  }),
                ])}
              >
                {icon}
              </span>
            </>
          ) : undefined}
        </div>
        {isFull && shouldShowCompleteIcon ? (
          <Icon name="Tick" className={styles.tickIcon({ hasIcon: !!icon, size })} />
        ) : null}
      </div>
    </>
  );
};
